var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2338 6.24998L10.58 0.804981C10.2538 -0.26377 8.7463 -0.26377 8.4313 0.804981L6.76629 6.24998H1.76005C0.668795 6.24998 0.218795 7.65623 1.10755 8.28623L5.20255 11.2112L3.5938 16.3975C3.26755 17.4437 4.48255 18.2875 5.3488 17.6237L9.50005 14.4737L13.6513 17.635C14.5175 18.2987 15.7325 17.455 15.4063 16.4087L13.7975 11.2225L17.8925 8.29748C18.7813 7.65623 18.3313 6.26123 17.24 6.26123H12.2338V6.24998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.3b00cd23.svg";
export { ForwardRef as ReactComponent };